import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function paHeroLanding() {
    const hero = document.querySelector('.pa-hero-landing');

    if (!hero) return;

    const pipes = gsap.utils.toArray('.pa-hero-landing .pipe-path');
    const mediaWrap = document.querySelector('.pa-hero-landing__media');

    // Pipes
    gsap.set(pipes, {
        drawSVG: '0% 0%',
        opacity: 0
    });

    gsap.to(pipes, {
        drawSVG: '0% 100%',
        duration: 1,
        opacity: 1,
        ease: 'power1.out',
        stagger: {
            each: 1
        }
    });

    // Media
    gsap.to(mediaWrap, {
        maxWidth: '948px',
        scrollTrigger: {
            trigger: mediaWrap,
            start: 'top 25%',
            scrub: 1
        }
    });
}
